import { UIButton, UIColor } from "uicore-ts"
import { CBButton } from "./CBButton"
import { CBColor } from "./CBColor"


export class CBFlatButton extends CBButton {
    
    static colors = {
        
        titleLabel: {
            
            normal: CBColor.primaryTintColor,
            highlighted: CBColor.primaryTintColor,
            selected: CBColor.primaryTintColor
            
        },
        background: {
            
            normal: CBColor.transparentColor,
            hovered: new UIColor("#F8F8F8"),
            highlighted: new UIColor("#ebebeb"),
            selected: new UIColor("#ebebeb")
            
        }
        
    }
    
    
    constructor(elementID?: string, elementType?: string) {
        
        super(elementID, elementType)
        
        this.colors = {
            
            titleLabel: {
                
                normal: CBColor.primaryTintColor,
                highlighted: CBColor.primaryTintColor,
                selected: CBColor.primaryTintColor
                
            },
            background: {
                
                normal: CBColor.transparentColor,
                hovered: new UIColor("#F8F8F8"),
                highlighted: new UIColor("#ebebeb"),
                selected: new UIColor("#ebebeb")
                
            }
            
        }
        
    }
    
    
    set titleLabelColor(titleLabelColor: UIColor) {
        
        
        this.colors.titleLabel.normal = titleLabelColor
        this.colors.titleLabel.highlighted = titleLabelColor
        this.colors.titleLabel.selected = titleLabelColor
        
        
        this.updateContentForCurrentState()
        
    }
    
    get titleLabelColor() {
        
        const result = this.colors.titleLabel.normal
        
        return result
        
    }
    
    
    override updateContentForNormalState() {
        
        UIButton.prototype.updateContentForNormalState.call(this)
        
        this.style.boxShadow = ""
        
    }
    
    
    override updateContentForHoveredState() {
        
        UIButton.prototype.updateContentForHoveredState.call(this)
        
        this.style.boxShadow = ""
        
    }
    
    override updateContentForFocusedState() {
        
        super.updateContentForFocusedState()
        
        // Use the highlighted background colour so keyboard-focused buttons are
        // visually distinct — matching the same appearance as a pressed button.
        this.backgroundView.backgroundColor = this.colors.background.highlighted
        this.style.outline = "none"
        this.style.boxShadow = "0 0 0 3px rgba(0, 100, 220, 0.35)"
        
    }
    
    
    override updateContentForHighlightedState() {
        
        UIButton.prototype.updateContentForHighlightedState.call(this)
        
        this.style.boxShadow = ""
        
    }
    
    
}

